module.exports = __webpack_public_path__ + "static/marine-operators-legal-liability-2032b1088f9641595a4f7e5e0fb15bd0.svg";